import * as types from 'modules/questionModels/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {string[]} State */
const initialState = [];

const updateFromChecklists = (_, { payload }) => payload.languages ?? [];

export default createReducer(initialState, {
  [types.FETCH_QUESTION_MODEL_SUCCESS]: updateFromChecklists,
  [types.UPDATE_QUESTION_MODEL_SUCCESS]: updateFromChecklists,
});
